<template>
  <div>
    <answer-render ref="answer" :config="config" :cvtLang="cvtLang">
      <div class="multinumber-box" slot="body">
        <div v-for="(item, index) in optionList.filter(item => item.visibility)" :key="item.id" class="item-box">
          <template>
            <div class="title" v-html="item.displayTitle"></div>
            <div v-if="item.imgUrl" class="medio-main">
              <ipsos-av v-if="isAv(item.imgUrl)" :src="item.imgUrl"></ipsos-av>
              <ipsos-image v-else :imgUrl="item.imgUrl" :preview="item.id"></ipsos-image>
            </div>
            <FormItem :prop="`optionList.${index}.value`" :rules="rules">
              <div class="input-box">
                <Input
                  class="textarea wyb"
                  v-model="item.value"
                  :placeholder="config.displayPlaceholder"
                  type="textarea"
                  :rows="config.answerConfig.inputSize"
                  :maxlength="1000"
                  @input="inputChange(index)"
                  @on-blur="blur(index)"
                />
                <span v-if="item.answerConfig" class="unit">{{ cvtLang(item.id + '-unit', item.answerConfig.unit) }}</span>
              </div>
            </FormItem>
            <!-- 不清楚/不知道 -->
            <div v-if="hasUnknownOption && item.optionList && item.optionList.length" :class="`unknown-box ${windowType === 'mobile' ? 'unknown-box-mobile' : ''}`">
              <el-radio v-model="item.optionList[0].value" @input="unknownChange(index)" label="-999">
                <span class="txt">{{ cvtLang(item.optionList[0].id, item.optionList[0].optionTitle) }}</span>
              </el-radio>
            </div>
          </template>
        </div>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
import { mapState } from 'vuex'
import util from '@/tools/commonUtil'
export default {
  name: 'MultiNumberBoxAnswer',
  props: ['config'],
  data () {
    return {
      hasUnknownOption: true,
      rules: [
        {
          validator: (rule, value, callback) => {
            const valIndex = Number(rule.field.split('.')[1])
            const errors = answerValidate.validate.bind(this.config)(this, true, valIndex).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapState({
      windowType: ({Question}) => Question.windowType,
      langMap: ({Question}) => Question.langMap,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
    }),
    optionList () {
      return this.config.optionList.filter(item => item.visibility)
    },
  },
  methods: {
    isAv (url) {
      return url && url.includes('.mp4')
    },
    blur(index) {
      const {precision} = this.config.optionList[index].answerConfig
      if (this.config.optionList[index].value && !this.config.optionList[index].value.trim()) {return}
      if (precision === 1) {
        this.config.optionList[index].value = util.formatNumber(this.config.optionList[index].value, 1)
      } else if (precision === 2) {
        this.config.optionList[index].value = util.formatNumber(this.config.optionList[index].value, 2)
      }
    },
    inputChange(index) {
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      if (this.optionList[index].value) {
        if (this.optionList[index].optionList && this.optionList[index].optionList[0]) {
          this.$set(this.optionList[index].optionList[0], 'value', '')
        }
      }
    },
    unknownChange(index) {
      // Todo: 校验触发
      this.optionList[index].value = ' '
      this.$nextTick(() => {
        this.optionList[index].value = ''
      })
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    }
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
.multinumber-box {
  margin-top: 15px;
  >>> .ivu-form-item {
    margin-bottom: 20px;
  }
  .item-box {
    margin-bottom: 30px;

    .title {
      font-size: 28px;
      margin-bottom: 10px;
    }
    .medio-main {
      margin-bottom: 20px;
      .av-wrap {
        width: 100% !important;
      }
      img {
        max-width: 100%;
      }
      >>> .video-js {
        width: 100% !important;
        height: 250px !important;
      }
    }
    .input-box {
      display: flex;
      .ivu-input-wrapper {
        flex: 1;
      }
      .unit {
        font-size: 28px;
        margin-left: 10px;
      }
    }
    .unknown-box {
      margin-top: 20px;
      >>> .el-radio {
        white-space: normal;
        line-height: 22px;
        word-break: break-word;
      }
      .txt {
        position: relative;
        left: -6px;
        top: 0px;
        font-weight: 400;
        color: #333;
        font-size: 28px;
      }
    }
    .unknown-box-mobile {
      >>> .el-radio {
        line-height: 48px;
        margin-right: 20px;
        display: flex;
        .el-radio__inner {
          width: 30px;
          height: 30px;
          position: relative;
          top: 8px;
          box-shadow:0 0 0 0 !important;
        }
        .el-radio__inner::after {
          width: 7px;
          height: 7px;
        }
        .el-radio__label {
          margin-left: 8px;
          line-height: 44px;
        }
      }
    }
  }
}
.answer-pc {
  .multinumber-box {
    margin-top: 0px;
    >>> .ivu-form-item {
      margin-bottom: 10px;
    }
    .item-box {
      margin-bottom: 15px;
      .title {
        font-size: 14px;
        margin-bottom: 5px;
      }
      .medio-main {
        margin-bottom: 10px;
        img {
          max-width: 100%;
        }
      }
      .unit {
        font-size: 14px;
        margin-left: 5px;
      }
      .unknown-box {
        margin-top: 10px;
        .txt {
          left: -3px;
          top: 1px;
          font-size: 14px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/editor/MultiNumberBox/MultiNumberBoxAnswer.vue